export const buildQuery = (params, globalFilterFields = [], ignoreFields = []) => {
    let paging = params.page >= 0 && params.rows > 0 ? `?page=${params.page}&size=${params.rows}` : "";
    let sort = params.sortField ? `sort=${params.sortField}:${params.sortOrder === 1 ? "ASC" : "DESC"}` : "";
    let query = paging.length > 0 ? `${paging}&${sort}` : sort;

    if (params.filters) {
        let filter = query.length > 0 ? "&query=" : "?query=";
        for (let field in params.filters) {
            if (!ignoreFields.some((e) => e === field)) {
                let value = params.filters[field]["value"];
                // string
                if (value && typeof value === "string") {
                    value = `${value?.trim()}`;
                    if (value?.includes(" ")) {
                        value = `'${value?.trim()}'`;
                    }
                }
                // boolean
                if (value || typeof value === "boolean") {
                    if (field === "global") {
                        if (globalFilterFields.length > 0) {
                            filter += `(`;
                            globalFilterFields.forEach((f) => {
                                filter += `${f}=ilike=${value},`;
                            });
                            filter = filter.slice(0, -1) + `)`;
                        }
                    } else {
                        let mode = params.filters[field]["matchMode"];
                        if (mode === "ilike") {
                            filter += `${field}=ilike=${value};`;
                        } else if (mode === "contains") {
                            filter += `${field}=like=${value};`;
                        } else if (mode === "notContains") {
                            filter += `${field}=notlike=${value};`;
                        } else if (mode === "startsWith") {
                            filter += `${field}==${value}*;`;
                        } else if (mode === "endsWith") {
                            filter += `${field}==*${value};`;
                        } else if (mode === "equals") {
                            filter += `${field}==${value};`;
                        } else if (mode === "notEquals") {
                            filter += `${field}!=${value};`;
                        } else if (mode === "in") {
                            filter += `${field}=in=${value};`;
                        } else if (mode === "lt") {
                            filter += `${field}=lt=${value};`;
                        } else if (mode === "lte") {
                            filter += `${field}=le=${value};`;
                        } else if (mode === "gt") {
                            filter += `${field}=gt=${value};`;
                        } else if (mode === "gte") {
                            filter += `${field}=ge=${value};`;
                        } else if (mode === "between") {
                            filter += `${field}=bt=${value};`;
                        }
                    }
                }
            }
        }

        if (filter.charAt(filter.length - 1) === ";" || filter.charAt(filter.length - 1) === ",") {
            filter = filter.substring(0, filter.length - 1);
        }

        query += filter;
    }
    return encodeURI(query);
};

export const buildDseQuery = (params, globalFilterFields = [], ignoreFields = []) => {
    let paging = params.page >= 0 && params.rows > 0 ? `?page=${params.page}&size=${params.rows}` : "";
    let sort = params.sortField ? `sort=${params.sortField}:${params.sortOrder === 1 ? "ASC" : "DESC"}` : "";
    let query = paging.length > 0 ? `${paging}&${sort}` : sort;

    if (params.filters) {
        let filter = query.length > 0 ? "&query=" : "?query=";
        for (let field in params.filters) {
            if (!ignoreFields.some((e) => e === field)) {
                let value = params.filters[field]["value"];
                // string
                if (value && typeof value === "string") {
                    value = `${value?.trim()}`;
                    if (value?.includes(" ")) {
                        value = `'${value?.trim()}'`;
                    }
                }
                // boolean
                if (value || typeof value === "boolean") {
                    if (field === "global") {
                        if (globalFilterFields.length > 0) {
                            filter += `(`;
                            globalFilterFields.forEach((f) => {
                                filter += `${f}==*${value}*,`;
                            });
                            filter = filter.slice(0, -1) + `)`;
                        }
                    } else {
                        let mode = params.filters[field]["matchMode"];

                        if (field === "startTime") {
                            field = "time";
                        } else if (field === "endTime") {
                            field = "time";
                        }
                        if (mode === "ilike") {
                            filter += `${field}=ilike=${value};`;
                        } else if (mode === "contains") {
                            filter += `${field}=="*${value}*";`;
                        } else if (mode === "startsWith") {
                            filter += `${field}=="${value}*";`;
                        } else if (mode === "endsWith") {
                            filter += `${field}=="*${value}";`;
                        } else if (mode === "equals") {
                            filter += `${field}=="${value}";`;
                        } else if (mode === "notEquals") {
                            filter += `${field}!="${value}";`;
                        } else if (mode === "in") {
                            filter += `${field}=in="${value}";`;
                        } else if (mode === "lt") {
                            filter += `${field}=lt="${value}";`;
                        } else if (mode === "lte") {
                            filter += `${field}=le="${value}";`;
                        } else if (mode === "gt") {
                            filter += `${field}=gt="${value}";`;
                        } else if (mode === "gte") {
                            filter += `${field}=ge="${value}";`;
                        } else if (mode === "between") {
                            filter += `${field}=bt="${value}";`;
                        }
                    }
                }
            }
        }

        if (filter.charAt(filter.length - 1) === ";" || filter.charAt(filter.length - 1) === ",") {
            filter = filter.substring(0, filter.length - 1);
        }

        query += filter;
    }

    return encodeURI(query);
};
